import features from './features';

const root = {
	features
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js